export default "__VITE_ASSET__B8_hfki1__"